// Persists across Shopify's AJAX variant-update swaps within the same page load: every
// shade/tab change replaces this element with a freshly server-rendered copy (which always
// renders the "All" state, since Liquid has no notion of client-side tab selection), so the
// active tab has to be restored from here each time a new instance connects.
let activeGroupKey = 'all';

if (!customElements.get('grouped-shade-picker')) {
  customElements.define(
    'grouped-shade-picker',
    class GroupedShadePicker extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-group-tab]'));
        this.groups = Array.from(this.querySelectorAll('[data-group]'));
        this.collectionInputs = Array.from(this.querySelectorAll('[data-collection-input]'));

        this.tabs.forEach((tab) => tab.addEventListener('click', this.onTabClick.bind(this)));
        // Fires for every shade selection, however it happens (tab auto-select or a direct
        // pill click, including a click on a shade from a different group while "All" is
        // showing everything at once). Runs before variant-selects reads the checked inputs,
        // since this element sits between the inputs and variant-selects in the DOM.
        this.addEventListener('change', this.onShadeChange.bind(this));

        // Restore whichever tab was active before this element was replaced. Don't
        // re-select/re-dispatch a shade here: the server already rendered the correct
        // shade as checked for the variant that triggered this update.
        this.showGroup(activeGroupKey, { selectFirstShade: false });
      }

      onShadeChange(event) {
        const target = event.target;
        if (target.tagName !== 'INPUT' || target.type !== 'radio' || target.hasAttribute('data-collection-input')) {
          return;
        }

        const groupDiv = target.closest('[data-group]');
        if (!groupDiv) return;

        const collectionInput = this.collectionInputs.find((input) => input.value === groupDiv.dataset.group);
        if (collectionInput && !collectionInput.checked) {
          collectionInput.checked = true;
        }
      }

      onTabClick(event) {
        this.showGroup(event.currentTarget.dataset.groupTab, { selectFirstShade: true });
      }

      showGroup(key, { selectFirstShade }) {
        activeGroupKey = key;

        this.tabs.forEach((tab) => {
          const isActive = tab.dataset.groupTab === key;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        const groupsToShow = key === 'all' ? this.groups : this.groups.filter((group) => group.dataset.group === key);
        this.groups.forEach((group) => {
          group.hidden = !groupsToShow.includes(group);
        });

        if (!selectFirstShade) return;

        const firstVisibleGroup = groupsToShow[0];
        if (!firstVisibleGroup) return;

        const firstShadeInput = firstVisibleGroup.querySelector('input[type="radio"]');
        if (firstShadeInput && !firstShadeInput.checked) {
          firstShadeInput.checked = true;
          firstShadeInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  );
}
